import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { FilmListContextInstance } from '../types/context';
import { useFilmListSchema } from '../utils/use-schema';
import { FilmListFilm } from './film';
const b = bemClassBuilder('v-film-list-grid');
export const FilmListGrid = observer(props => {
    const { films } = props;
    const { config } = useContext(FilmListContextInstance);
    const i18n = useI18n();
    useFilmListSchema(config.structuredData, films, i18n, config.filmUrlFactory);
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: films.map(film => (_jsx(FilmListFilm, { film: film }, film.id))) })));
});
FilmListGrid.displayName = 'FilmListGrid';
